import styles from './Cards.module.scss';
import clsx from 'clsx';

const Cards = props => {

  return (
    <div className={styles.a}> 
      <div className={styles.b}> 

        <div className={styles.d}>
          <h1>{props.title}</h1>
        </div>

        <div className={styles.c}>
          <div className={styles.e}>
            <img alt="icon" src={process.env.PUBLIC_URL + '/icons/' + props.cardImgId + '.png'} />
          </div>
          <p>
            {props.desc}
          </p>
        </div>

      </div>
    </div>
  );
};

export default Cards;